var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-lazy', {
    staticClass: "relative hover-pop-group clickable",
    class: 'n-' + _vm.pages.length,
    staticStyle: {
      "aspect-ratio": "1.5"
    },
    attrs: {
      "transition": ""
    }
  }, _vm._l(_vm.pages, function (page, i) {
    return _c(_vm.to ? 'router-link' : 'div', {
      key: i,
      tag: "component",
      staticClass: "page",
      class: _vm.rotations[i],
      attrs: {
        "to": _vm.to
      }
    }, [page.mp4 ? [_vm.IS_IOS_SAFARI ? _c('picture', [_c('source', {
      attrs: {
        "type": "video/mp4",
        "srcset": page.mp4
      }
    }), _c('img', {
      attrs: {
        "type": "image/webp",
        "src": page.webp,
        "alt": _vm.getAlt(i)
      }
    })]) : _c('video', {
      attrs: {
        "playsinline": "",
        "autoplay": "",
        "muted": "",
        "loop": "",
        "type": "video/mp4",
        "aria-label": _vm.getAlt(i),
        "src": page.mp4
      },
      domProps: {
        "muted": true
      }
    })] : _c('img', {
      attrs: {
        "type": 'image/' + (page.webp ? 'webp' : 'jpeg'),
        "src": page.webp ? page.webp : page.jpg,
        "alt": _vm.getAlt(i)
      }
    })], 2);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }